import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/config';
type ProductImageProps = {
  className?: string;
  linkToOffer?: boolean;
};
export function ProductImage({
  className = '',
  linkToOffer = true
}: ProductImageProps) {
  const img = <img src={PRODUCT_IMAGE} alt="Complete Postoperative Shoulder Rehabilitation System™ — 7 advanced clinical volumes plus 5 free professional bonuses" className={`mx-auto block h-auto w-full object-contain ${className}`} data-id="element-175" data-mp="2lk5034httt34" />;
  if (!linkToOffer) return img;
  return <a href={OFFER_ANCHOR} aria-label="Go to the special offer" className="block" data-id="element-176" data-mp="27kx2gg1bat11">
      {img}
    </a>;
}